import { IconColor } from '@/components/ui/icons/DynamicIcon/types/colors';
import type { Theme } from '@mui/material';
import styled from '@mui/material/styles/styled';
import StyleService from '@/services/StyleService/StyleService';

const getIconColor = (theme: Theme, iconColor?: IconColor) => {
  const colorGroupMap: Record<IconColor, keyof Theme['palette']> = {
    [IconColor.Info]: 'icon',
    [IconColor.VectorAdaptiveDark]: 'icon',
    [IconColor.VectorAdaptivePrimary]: 'icon',
    [IconColor.VectorAdaptiveBlueLight]: 'icon',
    [IconColor.VectorAdaptiveBlueDark]: 'icon',
    [IconColor.VectorAdaptiveOrange]: 'icon',
    [IconColor.VectorAdaptiveRedLight]: 'icon',
    [IconColor.VectorStaticWhite]: 'icon',
    [IconColor.VectorAdaptiveGreyInverted]: 'icon',
    [IconColor.VectorAdaptiveTertiaryDark]: 'icon',
    [IconColor.VectorAdaptiveGrey]: 'icon',
    [IconColor.VectorAdaptivePurple]: 'icon',
    [IconColor.VectorAdaptiveGreenDark]: 'icon',
    [IconColor.VectorAdaptiveDeepGreen]: 'icon',
    [IconColor.VectorAdaptiveSecondaryLight]: 'icon',
    [IconColor.VectorAdaptiveGreenLight]: 'icon',
    [IconColor.VectorAdaptiveWhite]: 'icon',
    [IconColor.blueDark]: 'tags',
    [IconColor.purpleDark]: 'tags',
    [IconColor.greenLight]: 'tags',
    [IconColor.deepGreenDark]: 'tags',
    [IconColor.greyDark]: 'tags',
    [IconColor.orange]: 'text',
  };

  if (iconColor && colorGroupMap[iconColor]) {
    return theme.palette[colorGroupMap[iconColor]][iconColor];
  }

  return;
};

export interface StyledDynamicIconBoxProps {
  fill?: IconColor;
  stroke?: IconColor;
  height?: number;
  withBackground?: boolean;
  backgroundColor?: string | null;
}

export const StyledDynamicIconBox = styled('div', {
  shouldForwardProp: StyleService.shouldNotForwardProps([
    'fill',
    'stroke',
    'height',
    'withBackground',
    'backgroundColor',
    'sx',
  ]),
})<StyledDynamicIconBoxProps>(({ theme, fill, stroke, height, withBackground, backgroundColor, sx = {} }: any) => {
  const bgStyles = withBackground
    ? {
        padding: 6,
        borderRadius: 4,
        background: backgroundColor ?? theme.palette.tags.greyLight,
      }
    : {};

  return {
    display: 'flex',
    alignItems: 'center',
    height,
    ...bgStyles,

    '& svg path': {
      fill: getIconColor(theme, fill),
      stroke: getIconColor(theme, stroke),
    },
    ...sx,
  };
});
